export default "__VITE_ASSET__C3Wl0Lk6__"